
function FlowingWaves({ scrollY }: { scrollY: number }) {
  return (
    <div className="fixed inset-0 bg-gradient-to-b from-purple-50 to-gray-50 overflow-hidden ">
      <div className="absolute inset-0">
        <svg className="absolute bottom-0 w-full h-48" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d={`M0,${60 + Math.sin(scrollY * 0.01) * 20} C300,${120 + Math.sin(scrollY * 0.008) * 15} 900,${Math.sin(scrollY * 0.012) * 25} 1200,${60 + Math.cos(scrollY * 0.01) * 20} L1200,120 L0,120 Z`}
            fill="rgba(139, 92, 246, 0.15)"
          />
          <path
            d={`M0,${80 + Math.cos(scrollY * 0.015) * 15} C300,${140 + Math.cos(scrollY * 0.01) * 20} 900,${20 + Math.sin(scrollY * 0.008) * 15} 1200,${80 + Math.sin(scrollY * 0.012) * 18} L1200,120 L0,120 Z`}
            fill="rgba(139, 92, 246, 0.1)"
          />
        </svg>
        <svg className="absolute top-0 w-full h-48 rotate-180" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d={`M0,${60 + Math.cos(scrollY * 0.008) * 15} C300,${120 + Math.cos(scrollY * 0.012) * 18} 900,${Math.cos(scrollY * 0.01) * 20} 1200,${60 + Math.sin(scrollY * 0.015) * 15} L1200,120 L0,120 Z`}
            fill="rgba(139, 92, 246, 0.12)"
          />
        </svg>
      </div>
    </div>
  )
}
export default FlowingWaves;